import type { TimelineEventVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveTimelineEvents = createApiThunk<TimelineEventVM[], string>(
  "timelineEvents/retrieveTimelineEvents",
  async (targetedUserId: string, { extra: { adminRepository } }) => {
    return adminRepository!.listTimelineEvents(targetedUserId);
  },
);
